export class Vacation {
  FechaInicial: string;
  FechaFinal: string;
  Motivo: string[];
}
